import { useDropdown } from '@/hooks/Dropdown-hook'
import { useAppSelector } from '@/store'
import { resetActivityData, setActivityFormData } from '@/store/slices/activitySlice'
import { ACTIVITY_TYPE } from '@/types/Activity'
import { DROPDOWN_TYPES } from '@/utils/constants/dropdownConstants'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getSegmentsList } from '@/services/rewards'

const useActivitySetup = () => {
  const dispatch = useDispatch()
  const activityTypes = useSelector(state => state.activity.activityTypes)
  const activityFormData = useAppSelector(state => state.activity.formData) // for Edit
   // Segments related state - fetch from API
   const [segments, setSegments] = useState([])
   const [segmentsLoading, setSegmentsLoading] = useState(false)

  const [formData, setFormData] = useState({
    allCustomers: true,
    excludeSegments: false,
    segments: [],
    excludedSegments: []
  })
  
  const [isInitialized, setIsInitialized] = useState(false)

  // Update formData when activityFormData changes (for edit mode)
  useEffect(() => {
    if (activityFormData && Object.keys(activityFormData).length > 0 && !isInitialized) {
      const hasSegments = activityFormData?.segments?.length > 0
      const hasExcludedSegments = activityFormData?.excludedSegments?.length > 0
      
      const newFormData = {
        ...activityFormData,
        allCustomers: !hasSegments && !hasExcludedSegments, // Set to false if segments exist
        excludeSegments: activityFormData?.excludeSegments ?? false,
        segments: activityFormData?.segments ?? [],
        excludedSegments: activityFormData?.excludedSegments ?? []
      }
      
      setFormData(newFormData)
      setIsInitialized(true)
    }
  }, [activityFormData, isInitialized])

  const { dropdownList, isLoading } = useDropdown({ dropdownType: DROPDOWN_TYPES.ActivitiesType })
  const [activityDropdownTypes, setActivityDropdownTypes] = useState({})
  
 

  useEffect(() => {
    const fetchSegments = async () => {
      setSegmentsLoading(true)
      try {
        const response = await getSegmentsList('', [])
        if (response?.success && Array.isArray(response?.data)) {
          setSegments(response.data)
        }
      } catch (error) {
        console.error('Failed to fetch segments:', error)
      } finally {
        setSegmentsLoading(false)
      }
    }
    
    fetchSegments()
  }, [])

  const handleFormChange = data => {
    if (data?.hasEndDate === false && data.activityType === ACTIVITY_TYPE.WELCOME_ACTIVITY) {
      delete data.endDate
      delete data.endDateValid
      setFormData(data)
      return
    }
    setFormData(prev => ({ ...prev, ...data }))
  }
  useEffect(() => {
    if (isInitialized) {
      dispatch(setActivityFormData(formData))
    }
  }, [formData, dispatch, isInitialized])

  const handleResetFormData = data => {
    // Only proceed if activityType is present in the data
    if (!data?.activityType) {
      return;
    }
    
    const activityType = data?.activityType;
    
    const defaultFormData = {
      activityType: activityType,
      hasEndDate: false,
      uuid: data?.uuid || '',
      id: data?.id || '', // Preserve the id
      allCustomers: true,
      excludeSegments: false,
      segments: [],
      excludedSegments: []
    }
    setFormData(defaultFormData)
    setIsInitialized(false) // Reset initialization flag
    dispatch(resetActivityData(defaultFormData))
  }

  // Segments handlers
  const handleAllCustomersChange = (value) => {
    const updatedData = { ...formData, allCustomers: value }
    if (value) {
      updatedData.segments = []
      updatedData.excludedSegments = []
      updatedData.excludeSegments = false
    }
    setFormData(updatedData)
  }

  const handleExcludeSegmentsChange = (value) => {
    const updatedData = { ...formData, excludeSegments: value }
    if (!value) {
      updatedData.excludedSegments = []
    }
    setFormData(updatedData)
  }

  const handleSegmentsChange = (segmentsData) => {
    setFormData(prev => ({ ...prev, segments: segmentsData }))
  }

  const handleExcludedSegmentsChange = (excludedSegmentsData) => {
    setFormData(prev => ({ ...prev, excludedSegments: excludedSegmentsData }))
  }

  useEffect(() => {
    // append dropdown data to activityTypes
    if (dropdownList?.length > 0) {
      let updatedDropdownData = JSON.parse(JSON.stringify(activityTypes))
      updatedDropdownData.properties.activityType.options = [...dropdownList]
      setActivityDropdownTypes(updatedDropdownData)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dropdownList])

  return {
    formData,
    activityTypes,
    handleFormChange,
    dropdownList,
    activityDropdownTypes,
    handleResetFormData,
    isLoading,
    segments,
    segmentsLoading,
    handleAllCustomersChange,
    handleExcludeSegmentsChange,
    handleSegmentsChange,
    handleExcludedSegmentsChange,
  }
}

export default useActivitySetup
